import "./Navbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Gets the current route
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);

  // Read cart count from localStorage instead of Redux
  useEffect(() => {
    const portfolio = JSON.parse(localStorage.getItem("userPortfolio")) || [];
    setCartCount(portfolio.length);
  }, []);

  // Determine if we are on the cart page to apply the black background
  const isCartPage = location.pathname === "/cart";

  return (
    <>
      <div className={`navbar ${isCartPage ? 'nav-dark-bg' : ''}`}>
        {/* --- LEFT LINKS --- */}
        <div className="links">
          {/* Shop Dropdown */}
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <p className="dropdown-trigger">
              Shop <i className="fa-solid fa-chevron-down dropdown-icon"></i>
            </p>
            {isDropdownOpen && (
              <div className="dropdown-menu">
                <span onClick={() => navigate("/allPaintings/All Paintings")}>Original</span>
                <span onClick={() => navigate("/allPrints")}>Prints</span>
              </div>
            )}
          </div>

          <p onClick={() => navigate("/customBiography")}>Custom Pictorial Biography</p>
          <p onClick={() => navigate("/contact")}>Contact</p>
          <p onClick={() => navigate("/about")}>Artist</p>
        </div>

        {/* --- CENTER LOGO --- */}
        <p className="logo" onClick={() => navigate("/")}>
          Anjaan's <span>Art</span>
        </p>

        {/* --- RIGHT LINKS --- */}
        <div className="links right-links">
          <div className="cart-icon-wrapper" onClick={() => navigate("/cart")}>
            <i className="fa-solid fa-bag-shopping"></i>
            {cartCount > 0 && <span className="cart-count-badge">{cartCount}</span>}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;